import { LANGUAGE_FLAGS } from './languages';
import React from 'react';
import styled from 'styled-components';
import { buttonVariants } from '../social/SocialButton';
import { motion } from 'framer-motion';

const Icon = styled(motion.div)`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  background: url(${props => LANGUAGE_FLAGS[props.lang]});
  background-size: cover;
  background-position: center center;
`;

const LangButton = ({ lang, still, onClick }) => (
  <Icon
    lang={lang}
    variants={buttonVariants}
    whileHover={!still ? { scale: 1.1 } : undefined}
    whileTap={!still ? { scale: 0.95 } : undefined}
    onClick={onClick}
  />
);

export default LangButton;
